
<template>
  <VirtualList
    :list="list"
    :dataComponent="dataComponent"
    @getData="getData"
    :finished="finished"
  />
</template>

<script>
import Bus from "@/utils/bus";
import VirtualList from "@/components/VirtualList";
import dataComponent from "@/views/Order/Index/components/AfterSaleItem";
import { AfterSaleList, getAfterSaleDetail } from "@/api/order/afterSale";
export default {
  components: { VirtualList },
  data() {
    return {
      dataComponent,
      list: [],
      finished: false,
      pagination: {
        page: 0,
        size: 10,
      },
    };
  },
  created() {
    Bus.$on("refreshAfterSaleData", this.refreshData);
  },
  methods: {
    getData() {
      const params = this.pagination;
      AfterSaleList(params).then((res) => {
        res.data.content.map((item) => {
          this.converData(item);
        });
        this.list.push(...res.data.content);
        if (res.data.content.length < this.pagination.size) {
          this.finished = true;
        } else {
          this.pagination.page++;
        }
      });
    },
    refreshData(id) {
      this.$store.dispatch("app/showLoading");
      getAfterSaleDetail({ id })
        .then((res) => {
          this.$store.dispatch("app/hideLoading");
          const i = this.list.findIndex((item) => item.id === res.data.id);
          this.$set(this.list, i, this.converData(res.data));
        })
        .catch((res) => {
          this.$store.dispatch("app/hideLoading");
        });
    },
    converData(data) {
      data.orderItemTotal = data.orderItems.reduce(
        (prev, cur) => Number(prev) + Number(cur.qty),
        0
      );
      return data;
    },
  },
};
</script>

<style>
</style>